import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { useState } from 'react';

import SimpleTable from '../common/SimpleTable';

import ProductViewModal from '@/components/modal/store/ProductViewModal';
import { useModal } from '@/hooks/useModal';
import { IProduct } from '@/interfaces/api/product/IProduct';

const ProductsTable = ({
	products,
	refetchProducts,
}: {
	products: IProduct[] | undefined;
	refetchProducts: () => void;
}) => {
	const [selectedProduct, setSelectedProduct] = useState<IProduct | null>(null);

	const handleViewProduct = (product: IProduct) => {
		setSelectedProduct(product);
		openViewProductModal();
	};

	const {
		modal: viewProductModal,
		openModal: openViewProductModal,
		closeModal: handleCloseModal,
	} = useModal({
		children: (
			<ProductViewModal
				closeModal={() => handleCloseModal()}
				productId={selectedProduct?.id || null}
				refetchProducts={refetchProducts}
			/>
		),
		closeOnOutClick: false,
		modalBoxClassName: 'max-w-6xl md:min-w-[500px]',
	});

	const columnHelper = createColumnHelper<IProduct>();

	const columns = [
		columnHelper.accessor('image', {
			cell: (info) => (
				<div className="w-[50px]">
					<img
						className="w-[30px]"
						src={info.getValue().src}
						alt={info.getValue().alt || 'Product image'}
					/>
				</div>
			),
			header: () => <div className="w-[50px]"></div>,
		}) as ColumnDef<IProduct>,
		columnHelper.display({
			id: 'actions',
			cell: (info) => (
				<div className="w-[60px]">
					<button
						className="font-normal text-blue-500 hover:underline"
						onClick={() => handleViewProduct(info.row.original)}
						data-test={`view-button-${info.row.original.id}`}
					>
						View
					</button>
				</div>
			),
			header: () => <div className="w-[60px]">VIEW</div>,
		}) as ColumnDef<IProduct>,
		columnHelper.accessor('id', {
			cell: (info) => <div className="w-[130px]">{info.getValue()}</div>,
			header: () => <div className="w-[130px]">SHOPIFY ID</div>,
		}) as ColumnDef<IProduct>,
		columnHelper.accessor('title', {
			cell: (info) => (
				<div className="w-[400px] text-ellipsis whitespace-normal">
					{info.getValue()}
				</div>
			),
			header: () => <div className="w-[400px]">TITLE</div>,
		}) as ColumnDef<IProduct>,
	];
	return (
		<div
			className="flex flex-col items-center border-t border-gray-300 w-full bg-grey-0 border rounded-md"
			data-test="store-products-table"
		>
			{products?.length ? (
				<SimpleTable collection={products || []} columns={columns} />
			) : (
				"This store doesn't have any products."
			)}
			{viewProductModal}
		</div>
	);
};

export default ProductsTable;
